import { render, staticRenderFns } from "./Ro_together.vue?vue&type=template&id=25453c40&scoped=true"
import script from "./Ro_together.vue?vue&type=script&lang=js"
export * from "./Ro_together.vue?vue&type=script&lang=js"
import style0 from "./Ro_together.vue?vue&type=style&index=0&id=25453c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25453c40",
  null
  
)

export default component.exports